$('.slickBanner').slick({
  dots: false,
  arrows: true,
  prevArrow: '.bBack',
  nextArrow: '.bNext',
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
});

$('#slickTestimonial').slick({
  dots: false,
  arrows: true,
  prevArrow: '.tBack',
  nextArrow: '.tNext',
  adaptiveHeight: true,
  adaptiveHeight: true,
  slidesToShow: 4,
  responsive: [
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 455,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false
      }
    }
  ]
});